import { useMutation, useQueryClient } from "@tanstack/react-query"
import { changeOrder } from "../actions/changeOrder.action"


export const useChangeAdminOrder = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (order: string[]) => changeOrder(order),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["business-owner"] });
        }
    })
}